export const AGREEMENT_QUANTITY_EXCEEDED = 'agreement_product_offered_quantity_exceeded';

/**
 * Client-side sentinel: the account was created, but its product has the
 * auto-attendant feature disabled (empty um_domain). Not emitted by the
 * backend — thrown by the AA creation saga so the catch block can tell this
 * case apart from a genuine API failure.
 */
export const AUTO_ATTENDANT_PRODUCT_RESTRICTIONS = 'Client.AutoAttendant.product_restrictions';

const SERVICE_NOT_ENABLED = 'Server.service_not_enabled';

/**
 * The extension exists, only its auto-attendant is off. Not a creation
 * failure from the user's point of view, so the creation dialog must not
 * fall back to its generic "contact your system administrator" state — the
 * saga already shows the explanatory toast and redirects to the extension.
 */
export function isAutoAttendantProductRestrictionFault(faultcode?: string | null): boolean {
    return (
        faultcode === AUTO_ATTENDANT_PRODUCT_RESTRICTIONS ||
        faultcode === SERVICE_NOT_ENABLED
    );
}

const LEGACY_MAX_OFFERED_QUANTITY = 'Server.Customer.Maximum offered quantity exceeded';
const LEGACY_MAX_QUANTITY_FOR_PRODUCT = 'Server.Account.Maximum offered quantity exceeded for product ID';

/**
 * Every faultcode the UI treats as "agreement product quantity exhausted".
 *
 * The legacy space-containing phrases must stay listed: backends on the
 * mr125-5 / mr129-1 / mr130-0 backport branches still emit them, while newer
 * ones send AGREEMENT_QUANTITY_EXCEEDED (prefixed with either Server.Account.
 * or Server.Customer., hence the substring match).
 *
 * Single source of truth on purpose — the creation dialogs decide whether to
 * show a field-level error through isMaxOfferedQuantityFault(), while the
 * sagas pass this same list to showToast() as the suppression list. Both must
 * agree, or the user gets a toast and a field error for the same fault.
 */
export const MAX_OFFERED_QUANTITY_FAULT_CODES = [
    AGREEMENT_QUANTITY_EXCEEDED,
    LEGACY_MAX_OFFERED_QUANTITY,
    LEGACY_MAX_QUANTITY_FOR_PRODUCT,
];

/**
 * Matches on faultcode only — the faultstring is inconsistent across backends
 * (sometimes the human phrase, sometimes the raw code).
 */
export function isMaxOfferedQuantityFault(faultcode?: string | null): boolean {
    const code = faultcode ?? '';

    return MAX_OFFERED_QUANTITY_FAULT_CODES.some((fault) => code.includes(fault));
}